import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import CmsIndex from '@/views-cms/index.vue';
import WebsiteIndex from '@/views-website/index.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    // 路由重定向
    redirect: () => {
      // 方法接收目标路由作为参数
      // return 重定向的字符串路径/路径对象 { path: '/search', query: { q: to.params.searchText } }
      return { path: '/website/home' };
    }
  },
  {
    path: '/cms',
    name: 'cms',
    component: CmsIndex,
    children: [
      { path: 'home', component: () => import('../views-cms/home/Home.vue') },
      { path: 'institutions', component: () => import('../views-cms/institution/Institution.vue') },
      {
        path: 'authorization-user',
        component: () => import('../views-cms/authorization-user/AuthorizationUser.vue')
      },
      { path: 'account-manage', component: () => import('../views-cms/account/manage/Manage.vue') },
      { path: 'account-log', component: () => import('../views-cms/account/log/Log.vue') },
      { path: 'order-list', component: () => import('../views-cms/account/order-list/OrderList.vue') }
    ]
  },
  {
    path: '/website',
    name: 'website',
    component: WebsiteIndex,
    children: [
      { path: 'home', component: () => import('../views-website/home/Home.vue') },
      { path: 'doc', component: () => import('../views-website/doc/Doc.vue') }
    ]
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
});

export default router;
